import { Component } from '@angular/core';

@Component({
  selector: 'xp-box',
  templateUrl: './box.component.html',
  styleUrl: './box.component.scss'
})
export class BoxComponent {

}
